import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { I18nService } from '../../shared/i18n/i18n.service';
import { TranslatePipe } from '../../shared/i18n/translate.pipe';

/** Jeden slajd karuzeli: obrazek plus klucze tłumaczeń podpisu. */
interface PromoSlide {
  image: string;
  titleKey: string;
  textKey: string;
}

/**
 * Karuzela screenshotów na stronie głównej - reklama funkcji serwisu.
 * Pisana ręcznie (w projekcie nie ma biblioteki do karuzel): slajdy leżą
 * jeden na drugim, aktywny dostaje opacity 1, przejście robi czysty CSS.
 */
@Component({
  selector: 'app-promo-carousel',
  templateUrl: './promo-carousel.component.html',
  styleUrls: ['./promo-carousel.component.css'],
  standalone: true,
  imports: [TranslatePipe],
})
export class PromoCarouselComponent implements OnInit, OnDestroy {
  readonly slides: PromoSlide[] = [
    {
      image: 'assets/screenshots/promo-tree.webp',
      titleKey: 'main.promoSlideTreeTitle',
      textKey: 'main.promoSlideTreeText',
    },
    {
      image: 'assets/screenshots/promo-fan.webp',
      titleKey: 'main.promoSlideFanTitle',
      textKey: 'main.promoSlideFanText',
    },
    {
      image: 'assets/screenshots/promo-profile.webp',
      titleKey: 'main.promoSlideProfileTitle',
      textKey: 'main.promoSlideProfileText',
    },
    {
      image: 'assets/screenshots/promo-path.webp',
      titleKey: 'main.promoSlidePathTitle',
      textKey: 'main.promoSlidePathText',
    },
  ];

  current = 0;
  paused = false;

  private intervalId: ReturnType<typeof setInterval> | null = null;
  /** Guard na typeof - testy Karma potrafią biec bez matchMedia. */
  private readonly reducedMotion =
    typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

  constructor(
    private zone: NgZone,
    private i18n: I18nService,
  ) {}

  /**
   * Zrzuty są w dwóch kompletach: promo-*.webp (PL) i promo-*.en.webp -
   * karuzela pokazuje ten w języku interfejsu, żeby napisy na obrazku
   * zgadzały się z resztą strony.
   */
  imageOf(slide: PromoSlide): string {
    return this.i18n.lang === 'en' ? slide.image.replace(/\.webp$/, '.en.webp') : slide.image;
  }

  ngOnInit(): void {
    if (this.reducedMotion) {
      return;
    }
    // Interval poza zone - potok `t` jest nieczysty, więc tick wewnątrz zone
    // przeliczałby wszystkie tłumaczenia w aplikacji co 6 sekund
    this.zone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        if (!this.paused) {
          this.zone.run(() => this.next());
        }
      }, 6000);
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }

  next(): void {
    this.current = (this.current + 1) % this.slides.length;
  }

  previous(): void {
    this.current = (this.current - 1 + this.slides.length) % this.slides.length;
  }

  goTo(index: number): void {
    this.current = index;
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
  }
}
